
import React from "react";
import { i18nManager } from "../../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { Elements } from "../../../shared/Elements";
import { CacheManager, Utils } from "../../../../utils";
import { Button, ButtonManageRef, Scheme } from "@rivtn/noseur";
import { ApiResponseData, BaseService, IMember, ISession, SanitizedResponse, SessionService } from "../../../../services";

export interface SessionsProps {
    profile: IMember;
}

function Sessions(props: SessionsProps) {

    const { profile: _ } = props;
    const sessionService = SessionService.getInstance();
    const labels = i18nManager.Labels.account.manage_account.sessions;
    const sessionToken: string = CacheManager.get(CacheManager.SESSION_TOKEN_KEY);
    const [sessions, setSessions] = React.useState<ApiResponseData<ISession>>({});
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);

    React.useEffect(fetchSession, []);

    return (<div className="account-setting">
        <div className="header">
            <span className="title">{i18nManager.Labels.account.manage_account.title} - {labels.title}</span>
            <span className="desc">{labels.desc}</span>
        </div>
        <div className="sessions">
            {Elements.buildPaginator(sessions ?? {}, ({ currentPage }, size) => Utils.updateSearchParamses({ "page": currentPage, id: null, size }, setSearchParams, fetchSession), parseInt(searchParams.get("page") ?? "1"))}
            <div className="list" style={{ paddingRight: 20, paddingTop: 10 }}>
                {sessions.content?.map((session: ISession, _: number) => {
                    let revokeManageRef: ButtonManageRef | null;
                    const isActiveSession = sessionToken?.startsWith(session.session_token?.substring(0, 20));
                    return (<div key={session.id} className="session">
                        <div>
                            <i className={Elements.selectSessionIcon(session.device?.device_class)} />
                            <div>
                                <div style={{ marginBottom: 5 }}><b><a href={`https://whatismyipaddress.com/ip/${session.ip_address}`} target="_blank">{session.ip_address}</a></b></div>
                                <span><b>{session.device?.browser_name}</b> {labels.on} <b>{session.device?.os_name}</b></span>
                                <span><b>{labels.location}:</b> {session.location?.state ?? labels.unknown}, {session.location?.country ?? labels.unknown}</span>
                                <span><b>{labels.last_activity}:</b> {Utils.formatToFineDate(session.updated_at)}</span>
                                <span><b>{labels.signed_in}:</b> {Utils.formatToFineDate(session.created_at)}</span>
                            </div>
                        </div>
                        {isActiveSession
                            ? (<Button scheme={Scheme.SECONDARY} text={labels.active_session} disabled />)
                            : (<Button borderless style={{ color: "#FF7171", backgroundColor: "rgba(255, 113, 113, 0.15)", padding: "10px 30px" }}
                                manageRef={(m) => revokeManageRef = m} text={session.status === "EXPIRED" ? labels.delete : labels.revoke} onClick={(_: any) => {
                                    revokeManageRef?.setLoadingState(true);
                                    sessionService.revokeSession(session.id).then(fetchSession).catch(BaseService.reportError).finally(() => revokeManageRef?.setLoadingState(false));
                                }} loadingProps={{ disabled: true, leftIcon: "fa fa-spinner fa-spin noseur-danger-tx" }} />)}
                    </div>);
                })}
            </div>
        </div>
    </div>);

    function fetchSession() {
        sessionService.querySession({
            "extra_data__object_like.platforms": "omnehost",
            page: parseInt(searchParams.get("page") ?? "1"),
            size: parseInt(searchParams.get("size") ?? "10"),
        }).then(({ apiResponse }: SanitizedResponse<ApiResponseData<ISession>>) => {
            setSessions(apiResponse.data!);
        }).catch(BaseService.reportError);
    }

}

export default Sessions;
